export default "__VITE_ASSET__Babm0h0e__"